// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

.moduleIconHover:hover {
  transform: scale(1.2);
  cursor: pointer;
}

.moduleIconSelected {
  transform: scale(1.2);
  color:white;
  cursor: pointer;
}
.multiSelectContainer {
  display:inline-block;
  margin-top: 0px;
}

.searchWrapper {
  overflow-y: auto;
  height: 37px;
  padding:2px
}

.content-area{
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  border-radius: 20px 0px 0px 20px ;
}




  


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iCAAiC;AACnC","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n.moduleIconHover:hover {\n  transform: scale(1.2);\n  cursor: pointer;\n}\n\n.moduleIconSelected {\n  transform: scale(1.2);\n  color:white;\n  cursor: pointer;\n}\n.multiSelectContainer {\n  display:inline-block;\n  margin-top: 0px;\n}\n\n.searchWrapper {\n  overflow-y: auto;\n  height: 37px;\n  padding:2px\n}\n\n.content-area{\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 100%;\n  border-radius: 20px 0px 0px 20px ;\n}\n\n\n\n\n  \n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
